// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"BackButton_backBtn__4qCXZ","noTopMargin":"BackButton_noTopMargin__ZELOz"};